module.exports = __webpack_public_path__ + "system/img/none-007.ab41e447.png";